import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
import { useParams } from 'wouter';
import { getAlertDetail, setAlertRead } from "../../services/api_dipendenti";
import Fetching from "../../components/fetching";
import moment from "moment";
import Footer from "../../components/footer";
import BackButton from "../../components/back_button";
import { useLocation, Link } from 'wouter';
import { Popover } from '@headlessui/react';
import { PaperClipIcon } from '@heroicons/react/24/outline';
import FilePreviewModal from "../../components/preview_modal";

export default function ArSingleMessage() {
  const { token } = useContext(AuthContext);
  const { resourceId } = useParams();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [previewDoc, setPreviewDoc] = useState(null);
  const [location] = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  const type = queryParams.get('type') || 'Comunicazioni';

  const handlePreviewAttachment = (attachment) => {
    setPreviewDoc({
      name: attachment.file_name || 'Allegato',
      url: attachment.file,
    });
  };

  useEffect(() => {
    const fetchMessage = async () => {
      try {
        const response = await getAlertDetail(token, resourceId);
        setMessage(response);

        if (response && !response.is_read) {
          try {
            await setAlertRead(token, resourceId);
          } catch (setAlertReadError) {
            console.error('Error marking alert as read:', setAlertReadError);
          }
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching message:', error);
        setIsError(true);
        setIsLoading(false);
      }
    };

    fetchMessage();
  }, [token, resourceId]);
  
  if (isLoading) {
    return <Fetching />;
  }
    
  if (isError || !message) {
    return (
      <div className="px-4 sm:px-6 lg:px-8 mt-5">
        <p className="text-red-500">Si è verificato un errore durante il caricamento del messaggio.</p>
      </div>
    );
  }

  return (
    <div className='flex flex-col min-h-screen'>
      <Popover as="header" className={`bg-indigo-200`}>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
            <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
              <div className="flex justify-center my-2 py-2">
                <h2 className="text-center text-2xl font-semibold text-indigo-800">Messaggi</h2>
              </div>
            </div>
          </div>
        </div>
      </Popover>
      <main className="flex-grow mt-10 pb-8">
        <div className='mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 pt-4'>
          <div className="flex justify-end w-full mb-6">
            <Link to={`/areariservata/avvisi?type=${type}`} className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600">
              Torna indietro
            </Link>
          </div>
          <div className="bg-white shadow overflow-hidden sm:rounded-lg">
            <div className="px-4 py-5 sm:px-6 bg-gray-50">
              <h3 className="text-lg leading-6 font-medium text-gray-900">{message.title}</h3>
              <p className="mt-1 max-w-2xl text-sm text-gray-500">{moment(message.created_at).format('DD/MM/YYYY HH:mm')}</p>
            </div>
            <div className="border-t border-gray-200">
              <dl>
                <div className="px-4 py-5">
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{message.message}</dd>
                </div>
                {message.attachments && Array.isArray(message.attachments) && message.attachments.length > 0 && (
                  <div className="px-4 py-5 border-t border-gray-200">
                    <dt className="text-xs font-medium uppercase tracking-wider text-gray-500">
                      Allegati
                    </dt>
                    <dd className="mt-2">
                      <div className="flex flex-col items-start space-y-2">
                        {message.attachments.map((attachment) => (
                          <button
                            key={attachment.id}
                            type="button"
                            onClick={() => handlePreviewAttachment(attachment)}
                            className="flex items-center max-w-full text-sm text-indigo-600 hover:text-indigo-800 hover:underline"
                          >
                            <PaperClipIcon className="w-4 h-4 mr-2 flex-shrink-0" />
                            <span className="truncate">
                              {attachment.file_name || 'Allegato'}
                            </span>
                          </button>
                        ))}
                      </div>
                    </dd>
                  </div>
                )}
              </dl>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <FilePreviewModal
        doc={previewDoc}
        onClose={() => setPreviewDoc(null)}
      />
    </div>
  );
}